var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElevadeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 16,
    viewBox: "0 0 103 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8323 1.71257H39.6299V4.27843e-05H28.0295V5.61655H29.8323V1.71257Z",
    fill: "url(#paint0_linear_9856_42410)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0295 7.08012V15.9996H39.6299V14.2871H29.8323V8.78812H38.6425V7.08012H28.0295Z",
    fill: "url(#paint1_linear_9856_42410)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0146 15.9996H25.6151V14.2871H15.8174L15.8219 7.08012H14.0146V15.9996Z",
    fill: "url(#paint2_linear_9856_42410)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8174 4.27843e-05H14.0146V5.61203H15.8174V4.27843e-05Z",
    fill: "url(#paint3_linear_9856_42410)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80279 1.71258H11.6005V5.62776e-05H0V5.61656H1.80279V1.71258Z",
    fill: "url(#paint4_linear_9856_42410)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.08013V15.9996H11.6005V14.2871H1.80733V8.78814H10.613V7.08013H0Z",
    fill: "url(#paint5_linear_9856_42410)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4749 5.60752L44.1014 5.62776e-05H42.0449L44.423 5.60752H46.4749Z",
    fill: "url(#paint6_linear_9856_42410)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6613 5.62776e-05L49.8814 13.6278L47.1001 7.07151H45.0527L48.835 16H50.9322L57.7267 5.62776e-05H55.6613Z",
    fill: "url(#paint7_linear_9856_42410)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0387 12.471H102.066V15.9955H89.6369V0H102.066V3.52444H93.0387V6.28071H100.34V9.78707H93.0387V12.471Z",
    fill: "url(#paint8_linear_9856_42410)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8728 12.0603C72.8728 12.0603 78.3401 12.0603 79.5631 12.0422C81.6287 12.0106 83.3635 10.1716 83.3997 7.98913C83.4314 5.97389 81.692 4.05352 79.7035 3.97219C78.7749 3.93152 74.0142 3.93601 71.31 3.94505C70.1595 3.94505 69.1132 3.28082 68.633 2.24157L67.5957 0.00493909C67.5957 0.00493909 78.2812 0.00494792 79.3955 0.0139849C82.9377 0.0456143 86.0405 2.38164 87.0099 5.7434C87.9928 9.15034 86.6837 12.7426 83.7123 14.7126C82.4847 15.526 81.1258 15.9914 79.6401 15.9959C77.9641 16.0004 77.3979 16.0004 76.4965 16.0004C75.3098 16.0004 74.2363 15.291 73.7788 14.1975L72.8774 12.0603H72.8728Z",
    fill: "url(#paint9_linear_9856_42410)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3232 6.23638H77.539V9.75173H73.7568C72.57 9.75173 71.4965 9.03781 71.039 7.94885L70.3232 6.23638Z",
    fill: "url(#paint10_linear_9856_42410)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5107 0.00476612H60.7873L54.0019 16.0002H57.9835L59.587 12.295H65.7429L67.2693 16.0002H71.3641C70.6892 14.4278 64.5107 0.00476612 64.5107 0.00476612ZM60.5383 9.24059L62.6899 4.06236H62.7079L64.787 9.24059H60.5337H60.5383Z",
    fill: "url(#paint11_linear_9856_42410)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9856_42410",
    x1: 51.053,
    y1: -0.231703,
    x2: 51.053,
    y2: 46.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9856_42410",
    x1: 51.053,
    y1: -12.8473,
    x2: 51.053,
    y2: 16.5597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9856_42410",
    x1: 51.053,
    y1: -12.8392,
    x2: 51.053,
    y2: 16.5597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9856_42410",
    x1: 51.2896,
    y1: -0.219007,
    x2: 51.2896,
    y2: 46.5068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9856_42410",
    x1: 51.053,
    y1: -0.218831,
    x2: 51.053,
    y2: 46.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9856_42410",
    x1: 51.053,
    y1: -12.8392,
    x2: 51.053,
    y2: 16.5597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9856_42410",
    x1: 51.0331,
    y1: -0.257863,
    x2: 51.0331,
    y2: 46.5572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9856_42410",
    x1: 51.0331,
    y1: -0.0903723,
    x2: 51.0331,
    y2: 16.3167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9856_42410",
    x1: 51.0331,
    y1: -1.45992,
    x2: 51.0331,
    y2: 15.9642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9856_42410",
    x1: 50.9953,
    y1: -1.51868,
    x2: 50.9953,
    y2: 15.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9856_42410",
    x1: 51.0651,
    y1: -35.2708,
    x2: 51.0651,
    y2: 44.2582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9856_42410",
    x1: 62.6853,
    y1: -1.51333,
    x2: 62.6853,
    y2: 15.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168DCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394458"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevadeLogo);
export default __webpack_public_path__ + "static/media/ElevadeLogo.e83c86690b296fb1472ba13faf789c8c.svg";
export { ForwardRef as ReactComponent };